import React, { useState, useEffect, useCallback } from 'react';
import './MerchantDetail.css';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

// ── SVG Icon Components ───────────────────────────────────────
const Icons = {
  ArrowLeft: () => (
    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 12H5" /><path d="M12 19l-7-7 7-7" />
    </svg>
  ),
  Store: () => (
    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" /><polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  ),
  DollarSign: () => (
    <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="1" x2="12" y2="23" /><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" />
    </svg>
  ),
  ShoppingCart: () => (
    <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6" />
    </svg>
  ),
  Package: () => (
    <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <line x1="16.5" y1="9.4" x2="7.5" y2="4.21" /><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z" /><polyline points="3.27 6.96 12 12.01 20.73 6.96" /><line x1="12" y1="22.08" x2="12" y2="12" />
    </svg>
  ),
  Users: () => (
    <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 00-3-3.87" /><path d="M16 3.13a4 4 0 010 7.75" />
    </svg>
  ),
  LogIn: () => (
    <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <path d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4" /><polyline points="10 17 15 12 10 7" /><line x1="15" y1="12" x2="3" y2="12" />
    </svg>
  ),
  Key: () => (
    <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 11-7.778 7.778 5.5 5.5 0 017.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" />
    </svg>
  ),
  Check: () => (
    <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
  X: () => (
    <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  XLg: () => (
    <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  AlertCircle: () => (
    <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  ),
  Ban: () => (
    <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" /><line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
    </svg>
  ),
  Mail: () => (
    <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" />
    </svg>
  ),
  Bell: () => (
    <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.73 21a2 2 0 01-3.46 0" />
    </svg>
  ),
  Trash: () => (
    <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
    </svg>
  ),
  Archive: () => (
    <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="21 8 21 21 3 21 3 8" /><rect x="1" y="3" width="22" height="5" /><line x1="10" y1="12" x2="14" y2="12" />
    </svg>
  ),
  Copy: () => (
    <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <rect x="9" y="9" width="13" height="13" rx="2" ry="2" /><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
    </svg>
  ),
  AlertTriangle: () => (
    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  Globe: () => (
    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" /><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" />
    </svg>
  ),
  Shield: () => (
    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  Tag: () => (
    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" />
    </svg>
  ),
  FileText: () => (
    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /><polyline points="10 9 9 9 8 9" />
    </svg>
  ),
  Activity: () => (
    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
    </svg>
  ),
  Clock: () => (
    <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  Plus: () => (
    <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),
  Wifi: () => (
    <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12.55a11 11 0 0114.08 0" /><path d="M1.42 9a16 16 0 0121.16 0" /><path d="M8.53 16.11a6 6 0 016.95 0" /><line x1="12" y1="20" x2="12.01" y2="20" />
    </svg>
  ),
  ExternalLink: () => (
    <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" /><polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" />
    </svg>
  ),
  Send: () => (
    <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <line x1="22" y1="2" x2="11" y2="13" /><polygon points="22 2 15 22 11 13 2 9 22 2" />
    </svg>
  ),
  Filter: () => (
    <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
    </svg>
  ),
  MapPin: () => (
    <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" /><circle cx="12" cy="10" r="3" />
    </svg>
  ),
  Phone: () => (
    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
    </svg>
  ),
  User: () => (
    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" /><circle cx="12" cy="7" r="4" />
    </svg>
  ),
  Monitor: () => (
    <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="3" width="20" height="14" rx="2" ry="2" /><line x1="8" y1="21" x2="16" y2="21" /><line x1="12" y1="17" x2="12" y2="21" />
    </svg>
  ),
  Copy: () => (
    <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <rect x="9" y="9" width="13" height="13" rx="2" ry="2" /><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
    </svg>
  ),
  CopyCheck: () => (
    <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
};

// ── Helper Functions ──────────────────────────────────────────
const formatDate = (date) => {
  if (!date) return 'N/A';
  return new Date(date).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

const formatDateTime = (date) => {
  if (!date) return 'N/A';
  return new Date(date).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const formatCurrency = (amount, currency = 'NGN') => {
  const num = parseFloat(amount) || 0;
  if (currency === 'NGN') {
    return '\u20A6' + num.toLocaleString('en-NG', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }
  return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(num);
};

const getAvatarColor = (name) => {
  const colors = ['#1a6f63', '#2563eb', '#7c3aed', '#ea580c', '#dc2626', '#0891b2', '#4f46e5', '#059669'];
  let hash = 0;
  const str = name || 'M';
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return colors[Math.abs(hash) % colors.length];
};

const getKYCBadgeText = (kyc) => {
  if (!kyc) return 'L0 - Not Started';
  const levels = { LEVEL_0: 'L0', LEVEL_1: 'L1', LEVEL_2: 'L2', LEVEL_3: 'L3' };
  const statuses = { APPROVED: 'Approved', PENDING_REVIEW: 'Pending', REJECTED: 'Rejected', NOT_STARTED: 'Not Started' };
  return `${levels[kyc.level] || 'L0'} - ${statuses[kyc.status] || 'Not Started'}`;
};

// ── API Helper ────────────────────────────────────────────────
const apiFetch = async (path, opts = {}) => {
  const response = await fetch(`${API_BASE}${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(opts.headers || {}) },
    ...opts,
  });
  return response;
};

// Helper to build storefront URL from slug
const getStorefrontUrl = (slug) => {
  if (!slug) return '#';

  // Use env variable for platform domain if set
  const platformDomain = process.env.REACT_APP_PLATFORM_DOMAIN;
  if (platformDomain) {
    const isLocalhost = platformDomain.includes('localhost');
    const protocol = isLocalhost ? 'http' : 'https';
    return `${protocol}://${slug}.${platformDomain}`;
  }

  // Auto-detect from current hostname
  const hostname = window.location.hostname;

  // If we're on localhost, use subdomain routing on port 3000
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `http://${slug}.localhost:3000`;
  }

  // Derive platform domain from admin hostname (strip admin./console. prefix)
  const derivedDomain = hostname.replace(/^(admin|console)\./, '');
  return `https://${slug}.${derivedDomain}`;
};

// ── Main Component ────────────────────────────────────────────
const MerchantDetail = ({ merchantId, onBack, adminUser, toast: externalToast }) => {
  // Toast: use external toast or fallback
  const toast = externalToast || {
    success: (msg) => console.log('[success]', msg),
    error: (msg) => console.error('[error]', msg),
    info: (msg) => console.info('[info]', msg),
  };

  // ── State ─────────────────────────────────────────────────
  const [activeTab, setActiveTab] = useState('overview');
  const [merchant, setMerchant] = useState(null);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState('');
  const [crnCopied, setCrnCopied] = useState(false);

  // Overview tab
  const [adminTags, setAdminTags] = useState([]);
  const [adminNotes, setAdminNotes] = useState('');
  const [notesSaved, setNotesSaved] = useState(true);
  const [showAddTag, setShowAddTag] = useState(false);
  const [newTag, setNewTag] = useState('');

  // Orders tab
  const [ordersSummary, setOrdersSummary] = useState(null);
  const [orders, setOrders] = useState([]);
  const [ordersLoading, setOrdersLoading] = useState(false);

  // Products tab
  const [products, setProducts] = useState([]);
  const [productsLoading, setProductsLoading] = useState(false);

  // Customers tab
  const [customers, setCustomers] = useState([]);
  const [customersLoading, setCustomersLoading] = useState(false);

  // Activity tab
  const [activity, setActivity] = useState([]);
  const [activityLoading, setActivityLoading] = useState(false);
  const [activityFilter, setActivityFilter] = useState('all');
  const [activityResource, setActivityResource] = useState('');
  const [activityActorUserId, setActivityActorUserId] = useState('');
  const [activityPage, setActivityPage] = useState(1);
  const [activityHasMore, setActivityHasMore] = useState(false);
  const [lastLogin, setLastLogin] = useState(null);
  const [activityTeamMembers, setActivityTeamMembers] = useState([]);

  // Slug history
  const [slugHistory, setSlugHistory] = useState(null);
  const [slugHistoryLoading, setSlugHistoryLoading] = useState(false);

  // Modals
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailSubject, setEmailSubject] = useState('');
  const [emailBody, setEmailBody] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteConfirmText, setDeleteConfirmText] = useState('');
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [reasonAction, setReasonAction] = useState(null);
  const [reasonText, setReasonText] = useState('');

  // ── Load Merchant Data ────────────────────────────────────
  const loadMerchant = useCallback(async () => {
    setLoading(true);
    try {
      const r = await apiFetch(`/admin/merchants/${merchantId}`);
      const d = await r.json();
      if (r.ok && d.merchant) {
        setMerchant(d.merchant);
        setAdminTags(d.merchant.adminTags || []);
        setAdminNotes(d.merchant.adminNotes || '');
        setNotesSaved(true);
      } else {
        toast.error(d.error || 'Failed to load merchant');
      }
    } catch {
      toast.error('Network error loading merchant');
    } finally {
      setLoading(false);
    }
  }, [merchantId]);

  useEffect(() => {
    if (merchantId) loadMerchant();
  }, [merchantId, loadMerchant]);

  // ── Load tab-specific data ────────────────────────────────
  const loadOrdersSummary = useCallback(async () => {
    setOrdersLoading(true);
    try {
      const r = await apiFetch(`/admin/merchants/${merchantId}/orders-summary?period=all`);
      const d = await r.json();
      if (r.ok) {
        setOrdersSummary(d.summary || d);
        setOrders(d.recentOrders || d.orders || []);
      }
    } catch {
      toast.error('Failed to load orders data');
    } finally {
      setOrdersLoading(false);
    }
  }, [merchantId]);

  const loadProducts = useCallback(async () => {
    setProductsLoading(true);
    try {
      const r = await apiFetch(`/admin/merchants/${merchantId}/products`);
      const d = await r.json();
      if (r.ok) {
        setProducts(d.products || []);
      }
    } catch {
      toast.error('Failed to load products');
    } finally {
      setProductsLoading(false);
    }
  }, [merchantId]);

  const loadCustomers = useCallback(async () => {
    setCustomersLoading(true);
    try {
      const r = await apiFetch(`/admin/merchants/${merchantId}/customers`);
      const d = await r.json();
      if (r.ok) {
        setCustomers(d.customers || []);
      }
    } catch {
      toast.error('Failed to load customers');
    } finally {
      setCustomersLoading(false);
    }
  }, [merchantId]);

  const loadActivity = useCallback(async (page = 1, filter = 'all', extra = {}) => {
    setActivityLoading(true);
    try {
      const params = new URLSearchParams({ page: String(page), limit: '20' });
      if (filter && filter !== 'all') params.set('action', filter);
      if (extra.resource)    params.set('resource',    extra.resource);
      if (extra.actorUserId) params.set('actorUserId', extra.actorUserId);
      if (extra.actorEmail)  params.set('actorEmail',  extra.actorEmail);
      const r = await apiFetch(`/admin/merchants/${merchantId}/activity?${params.toString()}`);
      const d = await r.json();
      if (r.ok) {
        const logs = d.logs || d.activity || [];
        if (page === 1) {
          setActivity(logs);
        } else {
          setActivity(prev => [...prev, ...logs]);
        }
        setActivityHasMore(logs.length >= 20);
        setLastLogin(d.lastLogin || null);
        setActivityTeamMembers(d.teamMembers || []);
      }
    } catch {
      toast.error('Failed to load activity');
    } finally {
      setActivityLoading(false);
    }
  }, [merchantId]);

  const loadSlugHistory = useCallback(async () => {
    setSlugHistoryLoading(true);
    try {
      const r = await apiFetch(`/admin/merchants/${merchantId}/slug-history`);
      const d = await r.json();
      if (r.ok) {
        setSlugHistory(d);
      }
    } catch {
      // Silently fail - slug history is supplemental
    } finally {
      setSlugHistoryLoading(false);
    }
  }, [merchantId]);

  // Load tab data on tab switch
  useEffect(() => {
    if (!merchantId) return;
    switch (activeTab) {
      case 'overview':
        if (!slugHistory) loadSlugHistory();
        break;
      case 'orders':
        if (!ordersSummary) loadOrdersSummary();
        break;
      case 'products':
        if (products.length === 0) loadProducts();
        break;
      case 'customers':
        if (customers.length === 0) loadCustomers();
        break;
      case 'activity':
        if (activity.length === 0) loadActivity(1, activityFilter);
        break;
      default:
        break;
    }
  }, [activeTab, merchantId]);

  // ── Action Handlers ───────────────────────────────────────
  const doAction = async (method, path, body, successMsg) => {
    setActionLoading(path);
    try {
      const r = await apiFetch(path, {
        method,
        body: body ? JSON.stringify(body) : undefined,
      });
      const d = await r.json();
      if (r.ok) {
        toast.success(successMsg || d.message || 'Action completed');
        await loadMerchant();
      } else {
        toast.error(d.error || 'Action failed');
      }
    } catch {
      toast.error('Network error');
    } finally {
      setActionLoading('');
    }
  };

  const handleImpersonate = () => {
    window.location.href = `${API_BASE}/admin/impersonate/${merchantId}`;
  };

  const [tempPasswordModal, setTempPasswordModal] = useState({ show: false, password: '' });

  const handleResetPassword = async () => {
    setActionLoading('reset-password');
    try {
      const r = await apiFetch(`/admin/merchants/${merchantId}/reset-password`, { method: 'POST' });
      const d = await r.json();
      if (r.ok && d.success) {
        // Show temporary password in a modal for easy copying
        const tempPwd = d.tempPassword || d.data?.temporaryPassword;
        if (tempPwd) {
          setTempPasswordModal({ show: true, password: tempPwd });
          toast.success('Password reset successfully');
        } else {
          toast.success('Password reset email sent successfully');
        }
      } else {
        toast.error(d.error || 'Failed to reset password');
      }
    } catch {
      toast.error('Network error');
    } finally {
      setActionLoading('');
    }
  };

  const copyTempPassword = () => {
    navigator.clipboard.writeText(tempPasswordModal.password);
    toast.success('Password copied to clipboard');
  };

  const handleApprove = () => doAction('POST', `/admin/merchants/${merchantId}/approve`, null, 'Merchant approved');
  const handleReject = () => {
    setReasonAction({ type: 'reject', label: 'Reject Merchant', endpoint: `/admin/merchants/${merchantId}/reject`, field: 'reason' });
    setReasonText('');
    setShowReasonModal(true);
  };
  const handleSuspend = () => {
    setReasonAction({ type: 'suspend', label: 'Suspend Merchant', endpoint: `/admin/merchants/${merchantId}/suspend`, field: 'reason' });
    setReasonText('');
    setShowReasonModal(true);
  };
  const handleUnsuspend = () => doAction('POST', `/admin/merchants/${merchantId}/unsuspend`, null, 'Merchant unsuspended');
  const handleBan = () => {
    setReasonAction({ type: 'ban', label: 'Ban Merchant', endpoint: `/admin/merchants/${merchantId}/ban`, field: 'reason' });
    setReasonText('');
    setShowReasonModal(true);
  };
  const handleUnban = () => doAction('POST', `/admin/merchants/${merchantId}/unban`, null, 'Merchant unbanned');
  const handleNudgeKYC = () => doAction('POST', `/admin/merchants/${merchantId}/nudge-kyc`, null, 'KYC nudge sent');

  const submitReasonAction = async () => {
    if (!reasonAction) return;
    // All merchant actions use POST
    await doAction('POST', reasonAction.endpoint, { [reasonAction.field]: reasonText || `${reasonAction.type} by admin` }, `Merchant ${reasonAction.type}ed`);
    setShowReasonModal(false);
    setReasonAction(null);
    setReasonText('');
  };

  // Tags
  const handleAddTag = async () => {
    if (!newTag.trim()) return;
    setActionLoading('add-tag');
    try {
      const r = await apiFetch(`/admin/merchants/${merchantId}/tags`, {
        method: 'POST',
        body: JSON.stringify({ tag: newTag.trim() }),
      });
      const d = await r.json();
      if (r.ok) {
        setAdminTags(d.tags || [...adminTags, newTag.trim()]);
        setNewTag('');
        setShowAddTag(false);
        toast.success('Tag added');
      } else {
        toast.error(d.error || 'Failed to add tag');
      }
    } catch {
      toast.error('Network error');
    } finally {
      setActionLoading('');
    }
  };

  const handleRemoveTag = async (tag) => {
    setActionLoading(`remove-tag-${tag}`);
    try {
      const r = await apiFetch(`/admin/merchants/${merchantId}/tags/${encodeURIComponent(tag)}`, {
        method: 'DELETE',
      });
      const d = await r.json();
      if (r.ok) {
        setAdminTags(d.tags || adminTags.filter(t => t !== tag));
        toast.success('Tag removed');
      } else {
        toast.error(d.error || 'Failed to remove tag');
      }
    } catch {
      toast.error('Network error');
    } finally {
      setActionLoading('');
    }
  };

  // Notes
  const handleSaveNotes = async () => {
    setActionLoading('save-notes');
    try {
      const r = await apiFetch(`/admin/merchants/${merchantId}/notes`, {
        method: 'PUT',
        body: JSON.stringify({ notes: adminNotes }),
      });
      const d = await r.json();
      if (r.ok) {
        setNotesSaved(true);
        toast.success('Notes saved');
      } else {
        toast.error(d.error || 'Failed to save notes');
      }
    } catch {
      toast.error('Network error');
    } finally {
      setActionLoading('');
    }
  };

  // Send Email
  const handleSendEmail = async () => {
    if (!emailSubject.trim() || !emailBody.trim()) {
      toast.error('Subject and body are required');
      return;
    }
    setActionLoading('send-email');
    try {
      const r = await apiFetch(`/admin/merchants/${merchantId}/send-email`, {
        method: 'POST',
        body: JSON.stringify({ subject: emailSubject, body: emailBody }),
      });
      const d = await r.json();
      if (r.ok) {
        toast.success('Email sent successfully');
        setShowEmailModal(false);
        setEmailSubject('');
        setEmailBody('');
      } else {
        toast.error(d.error || 'Failed to send email');
      }
    } catch {
      toast.error('Network error');
    } finally {
      setActionLoading('');
    }
  };

  // Delete
  const handleDelete = async () => {
    if (deleteConfirmText !== 'DELETE') {
      toast.error('Please type DELETE to confirm');
      return;
    }
    setActionLoading('delete');
    try {
      const r = await apiFetch(`/admin/merchants/${merchantId}`, {
        method: 'DELETE',
        body: JSON.stringify({ confirm: 'DELETE' }),
      });
      const d = await r.json();
      if (r.ok) {
        toast.success('Merchant deleted');
        if (onBack) onBack();
      } else {
        toast.error(d.error || 'Deletion failed');
      }
    } catch {
      toast.error('Network error');
    } finally {
      setActionLoading('');
      setShowDeleteModal(false);
    }
  };

  // Archive
  const handleArchive = async () => {
    setActionLoading('archive');
    try {
      const r = await apiFetch(`/admin/merchants/${merchantId}/archive`, {
        method: 'POST',
        body: JSON.stringify({ reason: 'Account archived by admin' }),
      });
      const d = await r.json();
      if (r.ok) {
        toast.success('Merchant archived');
        await loadMerchant();
      } else {
        toast.error(d.error || 'Archive failed');
      }
    } catch {
      toast.error('Network error');
    } finally {
      setActionLoading('');
      setShowArchiveModal(false);
    }
  };

  // ── Derived Data ──────────────────────────────────────────
  const storeName = merchant?.store?.name || merchant?.username || 'Unknown Merchant';
  const storeEmail = merchant?.email || '';
  const tier = merchant?.merchantTier || 'FREE';
  const appStatus = merchant?.store?.applicationStatus || 'PENDING';
  const isSuspended = merchant?.store?.isSuspended;
  const isBanned = merchant?.store?.isBanned;
  const kycData = merchant?.kyc;
  const orderCount = merchant?.store?._count?.orders || merchant?._count?.orders || 0;
  const customerCount = merchant?.store?._count?.customers || merchant?._count?.customers || 0;
  const productCount = merchant?.store?._count?.products || merchant?._count?.products || 0;
  const revenue = merchant?.totalRevenue || 0;
  const storeCurrency = merchant?.currency || 'NGN';

  // ── Loading State ─────────────────────────────────────────
  if (loading) {
    return (
      <div className="md-container">
        <button className="md-back-btn" onClick={onBack}>
          <Icons.ArrowLeft /> Back to Merchants
        </button>
        <div className="md-loading">
          <div className="md-spinner"></div>
          <p className="md-loading-text">Loading merchant details...</p>
        </div>
      </div>
    );
  }

  if (!merchant) {
    return (
      <div className="md-container">
        <button className="md-back-btn" onClick={onBack}>
          <Icons.ArrowLeft /> Back to Merchants
        </button>
        <div className="md-empty">
          <Icons.Store />
          <p>Merchant not found</p>
        </div>
      </div>
    );
  }

  // ── Tab Content Renderers ─────────────────────────────────
  const renderOverviewTab = () => (
    <div className="md-tab-content">
      {/* Stat Cards */}
      <div className="md-stats-grid">
        <div className="md-stat-card">
          <div className="md-stat-icon revenue"><Icons.DollarSign /></div>
          <div className="md-stat-content">
            <div className="md-stat-value">{formatCurrency(revenue, storeCurrency)}</div>
            <div className="md-stat-label">Revenue</div>
          </div>
        </div>
        <div className="md-stat-card">
          <div className="md-stat-icon orders"><Icons.ShoppingCart /></div>
          <div className="md-stat-content">
            <div className="md-stat-value">{orderCount.toLocaleString()}</div>
            <div className="md-stat-label">Orders</div>
          </div>
        </div>
        <div className="md-stat-card">
          <div className="md-stat-icon products"><Icons.Package /></div>
          <div className="md-stat-content">
            <div className="md-stat-value">{productCount.toLocaleString()}</div>
            <div className="md-stat-label">Products</div>
          </div>
        </div>
        <div className="md-stat-card">
          <div className="md-stat-icon customers"><Icons.Users /></div>
          <div className="md-stat-content">
            <div className="md-stat-value">{customerCount.toLocaleString()}</div>
            <div className="md-stat-label">Customers</div>
          </div>
        </div>
      </div>

      {/* Contact Information */}
      <div className="md-section">
        <h3 className="md-section-title"><Icons.User /> Contact Information</h3>
        <div className="md-info-grid">
          <div className="md-info-item">
            <span className="md-info-label">Name</span>
            <span className="md-info-value">
              {merchant.firstName || merchant.lastName
                ? `${merchant.firstName || ''} ${merchant.lastName || ''}`.trim()
                : 'Not provided'}
            </span>
          </div>
          <div className="md-info-item">
            <span className="md-info-label">Email</span>
            <span className="md-info-value">{storeEmail || 'N/A'}</span>
          </div>
          <div className="md-info-item">
            <span className="md-info-label">Phone</span>
            <span className="md-info-value">{merchant.phone || 'Not provided'}</span>
          </div>
          <div className="md-info-item">
            <span className="md-info-label">Username</span>
            <span className="md-info-value">{merchant.username || 'N/A'}</span>
          </div>
        </div>
      </div>

      {/* Store Info */}
      <div className="md-section">
        <h3 className="md-section-title"><Icons.Globe /> Store Information</h3>
        <div className="md-info-grid">
          <div className="md-info-item">
            <span className="md-info-label">Store URL</span>
            <span className="md-info-value">
              {merchant.store?.slug ? (
                <a href={getStorefrontUrl(merchant.store.slug)} target="_blank" rel="noopener noreferrer">
                  {merchant.store.slug} <Icons.ExternalLink />
                </a>
              ) : 'Not set'}
            </span>
          </div>
          <div className="md-info-item">
            <span className="md-info-label">Currency</span>
            <span className="md-info-value">{storeCurrency}</span>
          </div>
          <div className="md-info-item">
            <span className="md-info-label">Country</span>
            <span className="md-info-value">{merchant.country || 'Nigeria'}</span>
          </div>
          <div className="md-info-item">
            <span className="md-info-label">Theme</span>
            <span className="md-info-value">{merchant.store?.theme || 'Default'}</span>
          </div>
          <div className="md-info-item">
            <span className="md-info-label">Email Verified</span>
            <span className="md-info-value">{merchant.isEmailVerified ? 'Yes' : 'No'}</span>
          </div>
          <div className="md-info-item">
            <span className="md-info-label">Custom Domain</span>
            <span className="md-info-value">{merchant.store?.customDomain || 'None'}</span>
          </div>
        </div>
      </div>

      {/* KYC & Bank */}
      <div className="md-section">
        <h3 className="md-section-title"><Icons.Shield /> KYC & Bank Information</h3>
        <div className="md-info-grid">
          <div className="md-info-item">
            <span className="md-info-label">KYC Level</span>
            <span className="md-info-value">{kycData?.level || 'LEVEL_0'}</span>
          </div>
          <div className="md-info-item">
            <span className="md-info-label">KYC Status</span>
            <span className="md-info-value">{kycData?.status || 'NOT_STARTED'}</span>
          </div>
          <div className="md-info-item">
            <span className="md-info-label">Can Receive Payments</span>
            <span className="md-info-value">{kycData?.canReceivePayments ? 'Yes' : 'No'}</span>
          </div>
          <div className="md-info-item">
            <span className="md-info-label">Can Withdraw</span>
            <span className="md-info-value">{kycData?.canWithdrawFunds ? 'Yes' : 'No'}</span>
          </div>
          {kycData?.bankName && (
            <>
              <div className="md-info-item">
                <span className="md-info-label">Bank</span>
                <span className="md-info-value">{kycData.bankName}</span>
              </div>
              <div className="md-info-item">
                <span className="md-info-label">Account Name</span>
                <span className="md-info-value">{kycData.accountName}</span>
              </div>
              <div className="md-info-item">
                <span className="md-info-label">Account Number</span>
                <span className="md-info-value">{kycData.accountNumber}</span>
              </div>
            </>
          )}
        </div>
      </div>

      {/* Admin Tags */}
      <div className="md-section">
        <h3 className="md-section-title"><Icons.Tag /> Admin Tags</h3>
        <div className="md-tags-container">
          {adminTags.map((tag, idx) => (
            <span key={idx} className="md-tag">
              {tag}
              <button
                className="md-tag-remove"
                onClick={() => handleRemoveTag(tag)}
                disabled={actionLoading === `remove-tag-${tag}`}
                title="Remove tag"
              >
                <Icons.X />
              </button>
            </span>
          ))}
          {adminTags.length === 0 && !showAddTag && (
            <span style={{ fontSize: '13px', color: 'var(--text-light)' }}>No tags yet</span>
          )}
          {!showAddTag ? (
            <button className="md-add-tag-btn" onClick={() => setShowAddTag(true)}>
              <Icons.Plus /> Add Tag
            </button>
          ) : (
            <div className="md-tag-input-row">
              <input
                className="md-tag-input"
                type="text"
                placeholder="Enter tag..."
                value={newTag}
                onChange={e => setNewTag(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && handleAddTag()}
                autoFocus
              />
              <button className="md-tag-save-btn" onClick={handleAddTag} disabled={!newTag.trim() || actionLoading === 'add-tag'}>
                Add
              </button>
              <button className="md-tag-cancel-btn" onClick={() => { setShowAddTag(false); setNewTag(''); }}>
                Cancel
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Admin Notes */}
      <div className="md-section">
        <h3 className="md-section-title"><Icons.FileText /> Admin Notes</h3>
        <textarea
          className="md-notes-textarea"
          value={adminNotes}
          onChange={e => { setAdminNotes(e.target.value); setNotesSaved(false); }}
          placeholder="Add internal notes about this merchant..."
        />
        <div className="md-notes-actions">
          <button
            className="md-notes-save-btn"
            onClick={handleSaveNotes}
            disabled={notesSaved || actionLoading === 'save-notes'}
          >
            {actionLoading === 'save-notes' ? 'Saving...' : notesSaved ? 'Saved' : 'Save Notes'}
          </button>
        </div>
      </div>

      {/* Slug Change History */}
      {slugHistory && slugHistory.history && slugHistory.history.length > 0 && (
        <div className="md-section">
          <h3 className="md-section-title"><Icons.Globe /> Slug Change History</h3>
          <div className="md-slug-history">
            <div className="md-info-item" style={{ marginBottom: '12px' }}>
              <span className="md-info-label">Current Slug</span>
              <span className="md-info-value">
                <a href={getStorefrontUrl(slugHistory.currentSlug)} target="_blank" rel="noopener noreferrer">
                  {slugHistory.currentSlug} <Icons.ExternalLink />
                </a>
              </span>
            </div>
            {slugHistory.previousSlugs && slugHistory.previousSlugs.length > 0 && (
              <div className="md-info-item" style={{ marginBottom: '12px' }}>
                <span className="md-info-label">Previous Slugs</span>
                <span className="md-info-value">{slugHistory.previousSlugs.join(', ')}</span>
              </div>
            )}
            <table className="md-table" style={{ marginTop: '8px' }}>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Old Slug</th>
                  <th>New Slug</th>
                  <th>IP Address</th>
                </tr>
              </thead>
              <tbody>
                {slugHistory.history.map(entry => (
                  <tr key={entry.id}>
                    <td>{formatDateTime(entry.changedAt)}</td>
                    <td><code>{entry.oldSlug || '—'}</code></td>
                    <td><code>{entry.newSlug || '—'}</code></td>
                    <td>{entry.ipAddress || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Danger Zone */}
      <div className="md-danger-zone">
        <h3 className="md-section-title"><Icons.AlertTriangle /> Danger Zone</h3>
        <div className="md-danger-actions">
          <button className="md-danger-btn" onClick={() => setShowArchiveModal(true)}>
            <Icons.Archive /> Archive Merchant
          </button>
          <button className="md-danger-btn md-danger-delete" onClick={() => setShowDeleteModal(true)}>
            <Icons.Trash /> Delete Merchant
          </button>
        </div>
      </div>
    </div>
  );

  const renderOrdersTab = () => (
    <div className="md-tab-content">
      {ordersLoading ? (
        <div className="md-loading">
          <div className="md-spinner"></div>
          <p className="md-loading-text">Loading orders...</p>
        </div>
      ) : (
        <>
          {/* Order Stats */}
          {ordersSummary && (
            <div className="md-order-stats">
              <div className="md-order-stat">
                <div className="md-order-stat-value">{ordersSummary.total || ordersSummary.totalOrders || 0}</div>
                <div className="md-order-stat-label">Total</div>
              </div>
              <div className="md-order-stat">
                <div className="md-order-stat-value" style={{ color: 'var(--warning-color)' }}>{ordersSummary.pending || 0}</div>
                <div className="md-order-stat-label">Pending</div>
              </div>
              <div className="md-order-stat">
                <div className="md-order-stat-value" style={{ color: 'var(--info-color)' }}>{ordersSummary.processing || 0}</div>
                <div className="md-order-stat-label">Processing</div>
              </div>
              <div className="md-order-stat">
                <div className="md-order-stat-value" style={{ color: 'var(--success-color)' }}>{ordersSummary.completed || ordersSummary.delivered || 0}</div>
                <div className="md-order-stat-label">Completed</div>
              </div>
              <div className="md-order-stat">
                <div className="md-order-stat-value" style={{ color: 'var(--error-color)' }}>{ordersSummary.cancelled || 0}</div>
                <div className="md-order-stat-label">Cancelled</div>
              </div>
              <div className="md-order-stat">
                <div className="md-order-stat-value" style={{ color: 'var(--success-color)' }}>
                  {formatCurrency(ordersSummary.totalRevenue || ordersSummary.revenue || 0, storeCurrency)}
                </div>
                <div className="md-order-stat-label">Revenue</div>
              </div>
            </div>
          )}

          {/* Recent Orders Table */}
          <div className="md-table-container">
            <div className="md-table-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3>Recent Orders</h3>
              <span style={{ display: 'flex', gap: 14 }}>
                <a
                  href={`/discounts?merchantId=${merchantId}`}
                  className="md-link"
                  style={{ fontSize: 13, color: '#0d7463', fontWeight: 500, textDecoration: 'none' }}
                >
                  View discounts →
                </a>
                <a
                  href={`/merchants/${merchantId}/orders`}
                  className="md-link"
                  style={{ fontSize: 13, color: '#0d7463', fontWeight: 500, textDecoration: 'none' }}
                >
                  View all orders →
                </a>
              </span>
            </div>
            <div className="md-table-wrapper">
              {orders.length === 0 ? (
                <div className="md-empty">
                  <Icons.ShoppingCart />
                  <p>No orders found</p>
                </div>
              ) : (
                <table className="md-table">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Order #</th>
                      <th>Customer</th>
                      <th>Total</th>
                      <th>Status</th>
                      <th>Channel</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders.map(order => (
                      <tr key={order.id}>
                        <td>{formatDate(order.createdAt)}</td>
                        <td className="md-table-mono">{order.orderNumber || order.id?.slice(-8)}</td>
                        <td>
                          {order.customer?.firstName || order.customer?.name || order.customerName || 'Guest'}
                          {order.customer?.lastName ? ` ${order.customer.lastName}` : ''}
                        </td>
                        <td style={{ fontWeight: 600 }}>{formatCurrency(order.total || order.totalAmount, storeCurrency)}</td>
                        <td>
                          <span className={`md-table-status ${(order.status || 'pending').toLowerCase()}`}>
                            {(order.status || 'PENDING').replace(/_/g, ' ')}
                          </span>
                        </td>
                        <td>
                          <span className={`md-table-status ${(order.channel || 'storefront').toLowerCase()}`}>
                            {order.channel || 'STOREFRONT'}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );

  const renderProductsTab = () => (
    <div className="md-tab-content">
      {productsLoading ? (
        <div className="md-loading">
          <div className="md-spinner"></div>
          <p className="md-loading-text">Loading products...</p>
        </div>
      ) : (
        <div className="md-table-container">
          <div className="md-table-header">
            <h3>Products ({products.length})</h3>
          </div>
          <div className="md-table-wrapper">
            {products.length === 0 ? (
              <div className="md-empty">
                <Icons.Package />
                <p>No products found</p>
              </div>
            ) : (
              <table className="md-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Price</th>
                    <th>Quantity</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {products.map(product => (
                    <tr key={product.id}>
                      <td style={{ fontWeight: 600 }}>{product.name}</td>
                      <td>{formatCurrency(product.price, storeCurrency)}</td>
                      <td>{product.quantity != null ? product.quantity.toLocaleString() : 'N/A'}</td>
                      <td>
                        <span className={`md-table-status ${(product.status || (product.quantity === 0 ? 'out_of_stock' : 'active')).toLowerCase()}`}>
                          {product.status || (product.quantity === 0 ? 'OUT OF STOCK' : 'ACTIVE')}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}
    </div>
  );

  const renderCustomersTab = () => (
    <div className="md-tab-content">
      {customersLoading ? (
        <div className="md-loading">
          <div className="md-spinner"></div>
          <p className="md-loading-text">Loading customers...</p>
        </div>
      ) : (
        <div className="md-table-container">
          <div className="md-table-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h3>Customers ({customers.length})</h3>
            <a
              href={`/merchants/${merchantId}/customers`}
              className="md-link"
              style={{ fontSize: 13, color: '#0d7463', fontWeight: 500, textDecoration: 'none' }}
            >
              View all customers with LTV →
            </a>
          </div>
          <div className="md-table-wrapper">
            {customers.length === 0 ? (
              <div className="md-empty">
                <Icons.Users />
                <p>No customers found</p>
              </div>
            ) : (
              <table className="md-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Contact</th>
                    <th>Orders</th>
                    <th>Total Spent</th>
                    <th>Churn</th>
                  </tr>
                </thead>
                <tbody>
                  {customers.map(customer => (
                    <tr key={customer.id}>
                      <td style={{ fontWeight: 600 }}>{customer.name || customer.firstName || 'Guest'}{customer.lastName ? ` ${customer.lastName}` : ''}</td>
                      <td>
                        <div style={{ fontSize: '13px', color: 'var(--text)' }}>{customer.email || 'N/A'}</div>
                        {customer.phone && <div style={{ fontSize: '12px', color: 'var(--text-muted)' }}>{customer.phone}</div>}
                      </td>
                      <td>{customer.metrics?.orderCount ?? customer._count?.orders ?? customer.orderCount ?? 0}</td>
                      <td style={{ fontWeight: 600 }}>{formatCurrency(customer.metrics?.totalSpent ?? customer.totalSpent ?? 0, storeCurrency)}</td>
                      <td>
                        {customer.metrics?.churnRisk && (
                          <span style={{
                            padding: '2px 8px',
                            borderRadius: 999,
                            fontSize: 11,
                            fontWeight: 600,
                            background: {
                              ACTIVE:       '#dcfce7',
                              AT_RISK:      '#fef3c7',
                              DORMANT:      '#f3f4f6',
                              NEW:          '#cffafe',
                              NEVER_BOUGHT: '#fee2e2',
                            }[customer.metrics.churnRisk] || '#f3f4f6',
                            color: {
                              ACTIVE:       '#14532d',
                              AT_RISK:      '#92400e',
                              DORMANT:      '#6b7280',
                              NEW:          '#155e75',
                              NEVER_BOUGHT: '#991b1b',
                            }[customer.metrics.churnRisk] || '#374151',
                          }}>
                            {customer.metrics.churnRisk.replace('_', ' ')}
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}
    </div>
  );

  const renderActivityTab = () => {
    const getTimelineDotClass = (log) => {
      const status = log.statusCode || log.status;
      if (status >= 200 && status < 300) return 'success';
      if (status >= 400 && status < 500) return 'warning';
      if (status >= 500) return 'error';
      return '';
    };

    const getStatusCodeClass = (code) => {
      if (!code) return '';
      if (code >= 200 && code < 400) return 'success';
      return 'error';
    };

    // Server filters everything now — no client-side re-filter needed.
    const filteredActivity = activity;

    const resolveActorLabel = (log) => {
      const roleName = log?.metadata?.roleName;
      const isOwner  = log?.metadata?.isOwner;
      const memberId = log?.metadata?.memberId;

      // Match on userId first — that column is always populated (the
      // team member's own User.id). memberId (from metadata) is only
      // present when the JWT is a new team-member token.
      const tm = activityTeamMembers.find(m =>
        m.userId === log.userId || (memberId && m.memberId === memberId)
      );

      if (tm) {
        return {
          name:    tm.name || tm.email || 'Team member',
          role:    tm.roleName || roleName || (tm.isOwner ? 'Owner' : 'Member'),
          isOwner: !!tm.isOwner,
        };
      }
      if (isOwner) {
        return { name: log.userEmail || 'Owner', role: 'Owner', isOwner: true };
      }
      if (log.role === 'ADMIN') {
        return { name: log.userEmail || 'Platform admin', role: 'Platform admin', isOwner: false };
      }
      return { name: log.userEmail || '—', role: roleName || 'Member', isOwner: false };
    };

    const reload = (nextFilter = activityFilter, extra = {}) => {
      setActivityPage(1);
      loadActivity(1, nextFilter, {
        resource:    activityResource || undefined,
        actorUserId: activityActorUserId || undefined,
        ...extra,
      });
    };

    return (
      <div className="md-tab-content">
        {/* Last Login */}
        {lastLogin && (
          <div className="md-last-login">
            <Icons.Clock />
            <span>Last login: <strong>{formatDateTime(lastLogin)}</strong></span>
          </div>
        )}

        {/* Filters row — action / resource / team member */}
        <div className="md-activity-filter" style={{ flexWrap: 'wrap', gap: 12 }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <Icons.Filter /> Action
            <select
              value={activityFilter}
              onChange={e => { setActivityFilter(e.target.value); reload(e.target.value); }}
              style={{ marginLeft: 4 }}
            >
              <option value="all">All</option>
              <option value="write">Writes (POST)</option>
              <option value="update">Updates (PUT/PATCH)</option>
              <option value="delete">Deletes</option>
              <option value="login">Logins</option>
            </select>
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            Resource
            <select
              value={activityResource}
              onChange={e => { setActivityResource(e.target.value); reload(activityFilter, { resource: e.target.value || undefined }); }}
              style={{ marginLeft: 4 }}
            >
              <option value="">All</option>
              <option value="products">Products</option>
              <option value="orders">Orders</option>
              <option value="customers">Customers</option>
              <option value="discounts">Discounts</option>
              <option value="settlements">Wallet / settlements</option>
              <option value="team">Team</option>
            </select>
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            Actor
            <select
              value={activityActorUserId}
              onChange={e => { setActivityActorUserId(e.target.value); reload(activityFilter, { actorUserId: e.target.value || undefined }); }}
              style={{ marginLeft: 4, maxWidth: 220 }}
            >
              <option value="">Everyone</option>
              {activityTeamMembers.map(tm => (
                <option key={tm.userId} value={tm.userId}>
                  {tm.name || tm.email || tm.userId.slice(0, 8)} · {tm.roleName || 'Member'}{tm.isOwner ? ' (Owner)' : ''}
                </option>
              ))}
            </select>
          </label>
        </div>

        {activityLoading && activity.length === 0 ? (
          <div className="md-loading">
            <div className="md-spinner"></div>
            <p className="md-loading-text">Loading activity...</p>
          </div>
        ) : filteredActivity.length === 0 ? (
          <div className="md-empty">
            <Icons.Activity />
            <p>No activity found</p>
          </div>
        ) : (
          <>
            <div className="md-timeline">
              {filteredActivity.map((log, idx) => {
                const actor = resolveActorLabel(log);
                return (
                  <div key={log.id || idx} className="md-timeline-item">
                    <div className={`md-timeline-dot ${getTimelineDotClass(log)}`}></div>
                    <div className="md-timeline-content">
                      <div className="md-timeline-action">
                        {log.action || log.description || `${log.method || 'GET'} ${log.path || ''}`}
                      </div>
                      <div className="md-timeline-meta" style={{ flexWrap: 'wrap' }}>
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, background: actor.isOwner ? '#dcfce7' : '#eff6ff', color: actor.isOwner ? '#14532d' : '#1e40af', padding: '1px 8px', borderRadius: 999, fontSize: 11, fontWeight: 600 }}>
                          {actor.name}
                          <span style={{ opacity: 0.7 }}>· {actor.role}</span>
                        </span>
                        <span><Icons.Clock /> {formatDateTime(log.createdAt || log.timestamp)}</span>
                        {(log.ipAddress || log.ip) && <span><Icons.Wifi /> {log.ipAddress || log.ip}</span>}
                        {log.method && (
                          <span className={`md-timeline-method ${log.method}`}>{log.method}</span>
                        )}
                        {log.path && <span style={{ fontFamily: 'Monaco, monospace', fontSize: '11px' }}>{log.path}</span>}
                        {log.statusCode && (
                          <span className={`md-timeline-status-code ${getStatusCodeClass(log.statusCode)}`}>{log.statusCode}</span>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Load More */}
            {activityHasMore && (
              <div className="md-pagination">
                <button
                  className="md-page-btn"
                  onClick={() => {
                    const nextPage = activityPage + 1;
                    setActivityPage(nextPage);
                    loadActivity(nextPage, activityFilter, {
                      resource:    activityResource    || undefined,
                      actorUserId: activityActorUserId || undefined,
                    });
                  }}
                  disabled={activityLoading}
                >
                  {activityLoading ? 'Loading...' : 'Load More'}
                </button>
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  // ── Tabs definition ───────────────────────────────────────
  const tabs = [
    { id: 'overview', label: 'Overview', icon: <Icons.Store /> },
    { id: 'orders', label: 'Orders', icon: <Icons.ShoppingCart /> },
    { id: 'products', label: 'Products', icon: <Icons.Package /> },
    { id: 'customers', label: 'Customers', icon: <Icons.Users /> },
    { id: 'activity', label: 'Activity', icon: <Icons.Activity /> },
  ];

  // ── Render ────────────────────────────────────────────────
  return (
    <div className="md-container">
      {/* Back Button */}
      <button className="md-back-btn" onClick={onBack}>
        <Icons.ArrowLeft /> Back to Merchants
      </button>

      {/* Header Card */}
      <div className="md-header-card">
        <div className="md-header-top">
          {/* Avatar */}
          <div className="md-avatar" style={{ background: getAvatarColor(storeName) }}>
            {storeName.charAt(0).toUpperCase()}
          </div>

          {/* Info */}
          <div className="md-header-info">
            <h1 className="md-store-name">
              {merchant.firstName || merchant.lastName
                ? `${merchant.firstName || ''} ${merchant.lastName || ''}`.trim()
                : storeName}
            </h1>
            {(merchant.firstName || merchant.lastName) && merchant.store?.name && (
              <p className="md-store-subtitle">{merchant.store.name}</p>
            )}
            <p className="md-store-email">{storeEmail}</p>
            {merchant.merchantCode && (
              <button
                type="button"
                className="md-crn-chip"
                onClick={() => {
                  navigator.clipboard.writeText(merchant.merchantCode).then(() => {
                    setCrnCopied(true);
                    toast.success('CRN copied');
                    setTimeout(() => setCrnCopied(false), 1500);
                  });
                }}
                title="Copy CRN to clipboard"
                aria-label={`Copy CRN ${merchant.merchantCode}`}
              >
                <span className="md-crn-label">CRN</span>
                <span className="md-crn-value">{merchant.merchantCode}</span>
                <span className="md-crn-action" aria-hidden="true">
                  {crnCopied ? <Icons.CopyCheck /> : <Icons.Copy />}
                </span>
              </button>
            )}
            <p className="md-store-joined">Joined {formatDate(merchant.createdAt)}</p>
          </div>

          {/* Badges */}
          <div className="md-header-badges">
            <span className={`md-tier-badge ${tier}`}>{tier}</span>
            <span className={`md-status-badge ${appStatus.toLowerCase()}`}>{appStatus}</span>
            <span className="md-status-badge kyc">{getKYCBadgeText(kycData)}</span>
            {merchant.isEmailVerified && <span className="md-status-badge verified">Verified</span>}
            {!merchant.isEmailVerified && <span className="md-status-badge unverified">Unverified</span>}
            {isSuspended && <span className="md-status-badge suspended">Suspended</span>}
            {isBanned && <span className="md-status-badge banned">Banned</span>}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="md-actions-row">
          <button className="md-action-btn md-btn-info" onClick={handleImpersonate} disabled={!!actionLoading}>
            <Icons.LogIn /> Impersonate
          </button>
          <button className="md-action-btn" onClick={handleResetPassword} disabled={!!actionLoading}>
            <Icons.Key /> Reset Password
          </button>
          {appStatus !== 'APPROVED' && (
            <button className="md-action-btn md-btn-primary" onClick={handleApprove} disabled={!!actionLoading}>
              <Icons.Check /> Approve
            </button>
          )}
          {appStatus !== 'REJECTED' && (
            <button className="md-action-btn" onClick={handleReject} disabled={!!actionLoading}>
              <Icons.X /> Reject
            </button>
          )}
          {!isSuspended && (
            <button className="md-action-btn md-btn-warning" onClick={handleSuspend} disabled={!!actionLoading}>
              <Icons.AlertCircle /> Suspend
            </button>
          )}
          {isSuspended && (
            <button className="md-action-btn md-btn-primary" onClick={handleUnsuspend} disabled={!!actionLoading}>
              <Icons.Check /> Unsuspend
            </button>
          )}
          {!isBanned && (
            <button className="md-action-btn md-btn-danger" onClick={handleBan} disabled={!!actionLoading}>
              <Icons.Ban /> Ban
            </button>
          )}
          {isBanned && (
            <button className="md-action-btn md-btn-primary" onClick={handleUnban} disabled={!!actionLoading}>
              <Icons.Check /> Unban
            </button>
          )}
          {(!kycData || kycData.status !== 'APPROVED') && (
            <button className="md-action-btn" onClick={handleNudgeKYC} disabled={!!actionLoading}>
              <Icons.Bell /> Nudge KYC
            </button>
          )}
          <button className="md-action-btn" onClick={() => setShowEmailModal(true)} disabled={!!actionLoading}>
            <Icons.Mail /> Send Email
          </button>
        </div>
      </div>

      {/* Tabs */}
      <div className="md-tabs">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`md-tab ${activeTab === tab.id ? 'md-tab-active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.icon} {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      {activeTab === 'overview' && renderOverviewTab()}
      {activeTab === 'orders' && renderOrdersTab()}
      {activeTab === 'products' && renderProductsTab()}
      {activeTab === 'customers' && renderCustomersTab()}
      {activeTab === 'activity' && renderActivityTab()}

      {/* ── Modals ─────────────────────────────────────────── */}

      {/* Send Email Modal */}
      {showEmailModal && (
        <div className="md-modal-overlay" onClick={() => setShowEmailModal(false)}>
          <div className="md-modal" onClick={e => e.stopPropagation()}>
            <div className="md-modal-header">
              <h2>Send Email to Merchant</h2>
              <button className="md-modal-close" onClick={() => setShowEmailModal(false)}>
                <Icons.XLg />
              </button>
            </div>
            <div className="md-modal-body">
              <div className="md-form-group">
                <label className="md-form-label">To</label>
                <input className="md-form-input" type="text" value={storeEmail} disabled />
              </div>
              <div className="md-form-group">
                <label className="md-form-label">Subject</label>
                <input
                  className="md-form-input"
                  type="text"
                  placeholder="Email subject..."
                  value={emailSubject}
                  onChange={e => setEmailSubject(e.target.value)}
                  autoFocus
                />
              </div>
              <div className="md-form-group">
                <label className="md-form-label">Body (HTML supported)</label>
                <textarea
                  className="md-form-textarea"
                  placeholder="Email body content..."
                  value={emailBody}
                  onChange={e => setEmailBody(e.target.value)}
                />
              </div>
            </div>
            <div className="md-modal-footer">
              <button className="md-modal-btn" onClick={() => setShowEmailModal(false)}>Cancel</button>
              <button
                className="md-modal-btn md-modal-btn-primary"
                onClick={handleSendEmail}
                disabled={!emailSubject.trim() || !emailBody.trim() || actionLoading === 'send-email'}
              >
                <Icons.Send /> {actionLoading === 'send-email' ? 'Sending...' : 'Send Email'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="md-modal-overlay" onClick={() => setShowDeleteModal(false)}>
          <div className="md-modal" onClick={e => e.stopPropagation()}>
            <div className="md-modal-header">
              <h2>Delete Merchant</h2>
              <button className="md-modal-close" onClick={() => setShowDeleteModal(false)}>
                <Icons.XLg />
              </button>
            </div>
            <div className="md-modal-body">
              <p className="md-confirm-text">
                This will permanently delete <strong>{storeName}</strong> ({storeEmail}) and all associated data.
                This action cannot be undone.
              </p>
              <div className="md-form-group">
                <label className="md-form-label">Type DELETE to confirm</label>
                <input
                  className="md-confirm-input"
                  type="text"
                  placeholder="DELETE"
                  value={deleteConfirmText}
                  onChange={e => setDeleteConfirmText(e.target.value)}
                  autoFocus
                />
              </div>
            </div>
            <div className="md-modal-footer">
              <button className="md-modal-btn" onClick={() => { setShowDeleteModal(false); setDeleteConfirmText(''); }}>
                Cancel
              </button>
              <button
                className="md-modal-btn md-modal-btn-danger"
                onClick={handleDelete}
                disabled={deleteConfirmText !== 'DELETE' || actionLoading === 'delete'}
              >
                {actionLoading === 'delete' ? 'Deleting...' : 'Delete Permanently'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Archive Confirmation Modal */}
      {showArchiveModal && (
        <div className="md-modal-overlay" onClick={() => setShowArchiveModal(false)}>
          <div className="md-modal" onClick={e => e.stopPropagation()}>
            <div className="md-modal-header">
              <h2>Archive Merchant</h2>
              <button className="md-modal-close" onClick={() => setShowArchiveModal(false)}>
                <Icons.XLg />
              </button>
            </div>
            <div className="md-modal-body">
              <p className="md-confirm-text">
                Are you sure you want to archive <strong>{storeName}</strong>? The merchant will lose access to their dashboard.
              </p>
            </div>
            <div className="md-modal-footer">
              <button className="md-modal-btn" onClick={() => setShowArchiveModal(false)}>Cancel</button>
              <button
                className="md-modal-btn md-modal-btn-danger"
                onClick={handleArchive}
                disabled={actionLoading === 'archive'}
              >
                {actionLoading === 'archive' ? 'Archiving...' : 'Archive Merchant'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Reason Modal (Suspend / Ban / Reject) */}
      {showReasonModal && reasonAction && (
        <div className="md-modal-overlay" onClick={() => setShowReasonModal(false)}>
          <div className="md-modal" onClick={e => e.stopPropagation()}>
            <div className="md-modal-header">
              <h2>{reasonAction.label}</h2>
              <button className="md-modal-close" onClick={() => setShowReasonModal(false)}>
                <Icons.XLg />
              </button>
            </div>
            <div className="md-modal-body">
              <p className="md-confirm-text">
                {reasonAction.type === 'reject' && `This will reject ${storeName}'s application.`}
                {reasonAction.type === 'suspend' && `This will suspend ${storeName}'s account. They will not be able to access their dashboard.`}
                {reasonAction.type === 'ban' && `This will ban ${storeName} from the platform permanently.`}
              </p>
              <div className="md-form-group">
                <label className="md-form-label">Reason</label>
                <textarea
                  className="md-form-textarea"
                  placeholder="Provide a reason..."
                  value={reasonText}
                  onChange={e => setReasonText(e.target.value)}
                  autoFocus
                  style={{ minHeight: '100px' }}
                />
              </div>
            </div>
            <div className="md-modal-footer">
              <button className="md-modal-btn" onClick={() => { setShowReasonModal(false); setReasonAction(null); }}>
                Cancel
              </button>
              <button
                className="md-modal-btn md-modal-btn-danger"
                onClick={submitReasonAction}
                disabled={!!actionLoading}
              >
                {actionLoading ? 'Processing...' : `Confirm ${reasonAction.label}`}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Temporary Password Modal */}
      {tempPasswordModal.show && (
        <div className="md-modal-overlay" onClick={() => setTempPasswordModal({ show: false, password: '' })}>
          <div className="md-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: '420px' }}>
            <div className="md-modal-header">
              <h2>Password Reset Successful</h2>
              <button className="md-modal-close" onClick={() => setTempPasswordModal({ show: false, password: '' })}>
                <Icons.XLg />
              </button>
            </div>
            <div className="md-modal-body">
              <p style={{ marginBottom: '16px', color: '#666' }}>
                A temporary password has been generated. Share this with the merchant:
              </p>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '12px 16px',
                background: '#f8f9fa',
                borderRadius: '8px',
                border: '1px solid #e9ecef'
              }}>
                <code style={{
                  flex: 1,
                  fontSize: '18px',
                  fontWeight: '600',
                  letterSpacing: '1px',
                  color: '#0D7463'
                }}>
                  {tempPasswordModal.password}
                </code>
                <button
                  onClick={copyTempPassword}
                  style={{
                    padding: '8px 16px',
                    background: '#0D7463',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    fontSize: '14px'
                  }}
                >
                  <Icons.Copy /> Copy
                </button>
              </div>
              <p style={{ marginTop: '16px', fontSize: '13px', color: '#888' }}>
                An email has also been sent to the merchant with this password.
              </p>
            </div>
            <div className="md-modal-footer">
              <button
                className="md-modal-btn md-modal-btn-primary"
                onClick={() => setTempPasswordModal({ show: false, password: '' })}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MerchantDetail;
